import React, {memo} from "react";
import PropTypes from "prop-types";
import {Chip} from "@mui/material";
import StyledChip from "./StyledChip";

const StatusChip = memo(({status, enableText, disableText}) => {
  const label = status ? enableText || "Enabled" : disableText || "Disabled";
  if (!status) {
    return <StyledChip defaultLabel={label} size="small" />;
  }
  return <Chip label={label} color="primary" size="small" />;
});

StatusChip.displayName = "StatusChip";

StatusChip.propTypes = {
  status: PropTypes.bool.isRequired,
  enableText: PropTypes.string,
  disableText: PropTypes.string,
};

export default StatusChip;
